var _Guid_a, _Guid_b, _Guid_c, _Guid_d, _Guid_e, _Guid_f, _Guid_g, _Guid_h, _Guid_i, _Guid_j, _Guid_k;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import UnsignedInt32 from './Numbers/Integers/UnsignedInt32';
import UnsignedInt16 from './Numbers/Integers/UnsignedInt16';
import Byte from './Numbers/Integers/Byte';
import padLeft from './Strings/padLeft';
import StringBuilder from './IO/StringBuilder';
const PARSE_FILTER_REGEX = /[-{}[\]]/gi;
/**
 * Represents a GUID
 */
export default class Guid {
    /**
     * Creates a new Guid by specifying all the parts
     * @param a
     * @param b
     * @param c
     * @param d
     * @param e
     * @param f
     * @param g
     * @param h
     * @param i
     * @param j
     * @param k
     */
    constructor(a, b, c, d, e, f, g, h, i, j, k) {
        _Guid_a.set(this, void 0);
        _Guid_b.set(this, void 0);
        _Guid_c.set(this, void 0);
        _Guid_d.set(this, void 0);
        _Guid_e.set(this, void 0);
        _Guid_f.set(this, void 0);
        _Guid_g.set(this, void 0);
        _Guid_h.set(this, void 0);
        _Guid_i.set(this, void 0);
        _Guid_j.set(this, void 0);
        _Guid_k.set(this, void 0);
        __classPrivateFieldSet(this, _Guid_a, a, "f");
        __classPrivateFieldSet(this, _Guid_b, b, "f");
        __classPrivateFieldSet(this, _Guid_c, c, "f");
        __classPrivateFieldSet(this, _Guid_d, d, "f");
        __classPrivateFieldSet(this, _Guid_e, e, "f");
        __classPrivateFieldSet(this, _Guid_f, f, "f");
        __classPrivateFieldSet(this, _Guid_g, g, "f");
        __classPrivateFieldSet(this, _Guid_h, h, "f");
        __classPrivateFieldSet(this, _Guid_i, i, "f");
        __classPrivateFieldSet(this, _Guid_j, j, "f");
        __classPrivateFieldSet(this, _Guid_k, k, "f");
    }
    /** Returns the Guid as a hypen-separated string without curly braces. */
    toString() {
        const sb = new StringBuilder();
        const zero = '0';
        const spacer = '-';
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_a, "f").valueOf() >>> 0).toString(16), 8, zero));
        sb.append(spacer);
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_b, "f").valueOf() >>> 0).toString(16), 4, zero));
        sb.append(spacer);
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_c, "f").valueOf() >>> 0).toString(16), 4, zero));
        sb.append(spacer);
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_d, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_e, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(spacer);
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_f, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_g, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_h, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_i, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_j, "f").valueOf() >>> 0).toString(16), 2, zero));
        sb.append(padLeft((__classPrivateFieldGet(this, _Guid_k, "f").valueOf() >>> 0).toString(16), 2, zero));
        return sb.toString();
    }
    /** Returns the Guid as a hypen-separated string without curly braces. */
    valueOf() {
        return this.toString();
    }
    /** Creates a new v4 GUID (its random except for the version nibble)*/
    static newGuid() {
        return new Guid(randomInt32(), randomInt16(), new UnsignedInt16((randomInt16().valueOf() & 0x0FFF) | 0x4000), new Byte(randomByte().valueOf() | 0xA), randomByte(), randomByte(), randomByte(), randomByte(), randomByte(), randomByte(), randomByte());
    }
    /**
     * converts astring representaion of a Guid into a Guid object.
     * @param str
     */
    static parseString(str) {
        const guid = str.replace(PARSE_FILTER_REGEX, '');
        return new Guid(new UnsignedInt32(parseInt(guid.substr(0, 8), 16)), new UnsignedInt16(parseInt(guid.substr(8, 4), 16)), new UnsignedInt16(parseInt(guid.substr(12, 4), 16)), new Byte(parseInt(guid.substr(16, 2), 16)), new Byte(parseInt(guid.substr(18, 2), 16)), new Byte(parseInt(guid.substr(20, 2), 16)), new Byte(parseInt(guid.substr(22, 2), 16)), new Byte(parseInt(guid.substr(24, 2), 16)), new Byte(parseInt(guid.substr(26, 2), 16)), new Byte(parseInt(guid.substr(28, 2), 16)), new Byte(parseInt(guid.substr(30, 2), 16)));
    }
}
_Guid_a = new WeakMap(), _Guid_b = new WeakMap(), _Guid_c = new WeakMap(), _Guid_d = new WeakMap(), _Guid_e = new WeakMap(), _Guid_f = new WeakMap(), _Guid_g = new WeakMap(), _Guid_h = new WeakMap(), _Guid_i = new WeakMap(), _Guid_j = new WeakMap(), _Guid_k = new WeakMap();
/** An empty Guid (all zero's) */
Guid.empty = new Guid(new UnsignedInt32(0), new UnsignedInt16(0), new UnsignedInt16(0), new Byte(0), new Byte(0), new Byte(0), new Byte(0), new Byte(0), new Byte(0), new Byte(0), new Byte(0));
function randomByte() {
    return new Byte(randomNumber(Byte.minValue.valueOf(), Byte.maxValue.valueOf()));
}
function randomInt16() {
    return new UnsignedInt16(randomNumber(UnsignedInt16.minValue.valueOf(), UnsignedInt16.maxValue.valueOf()));
}
function randomInt32() {
    return new UnsignedInt32(randomNumber(UnsignedInt32.minValue.valueOf(), UnsignedInt32.maxValue.valueOf()));
}
// TODO: This can be better
function randomNumber(min, max) {
    const rand = Math.random();
    const num = Math.floor(rand * (max + 1)) + min;
    return num > max ? max : num;
}
